import { render, staticRenderFns } from "./GiveupPrivilege.vue?vue&type=template&id=0ce2915c&"
import script from "./GiveupPrivilege.vue?vue&type=script&lang=js&"
export * from "./GiveupPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./GiveupPrivilege.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports